import React, { useState } from "react";
import Lightbox from "../gallery/Lightbox";

/**
 * รูปประกอบเนื้อหา (global.image-content) — โชว์ทั้งรูปตามสัดส่วนจริง ไม่ crop
 * กดที่รูปเพื่อดูขนาดเต็มจอ
 */
export default function ContentImage({ image, lang }) {
  const [open, setOpen] = useState(false);

  if (!image?.url) {
    return <div className="w-full rounded-[12px] min-h-[207px] bg-lightGray2" />;
  }

  return (
    <div className="w-full">
      <img
        src={`${process.env.REACT_APP_API_URL}${image.url}`}
        alt={image.alternativeText || image.name || ""}
        className="w-full h-auto rounded-[12px] cursor-zoom-in"
        onClick={() => setOpen(true)}
      />
      {open && (
        <Lightbox
          images={[image]}
          index={0}
          onChange={() => {}}
          onClose={() => setOpen(false)}
          lang={lang}
        />
      )}
    </div>
  );
}
